module.exports = __webpack_public_path__ + "img/caas2m.47dcec33.webp";